<template>
    <div class="body">
        <div class="popup-container">
            <div class="popup-icon">
                <!-- Example Icon (Lock) -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2a4 4 0 0 0-4 4v4H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-2V6a4 4 0 0 0-4-4zm-2 6V6a2 2 0 0 1 4 0v4h-4zm10 12H6v-8h12v8z"/></svg>
            </div>
            <div class="popup-text pt-2">
                <span>Access restricted!</span><br />
                Contact your admin to unlock this service.
            </div>
            <div class="popup-button">
                <button @click="back">Go Back</button>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    export default {
        name: "Assessmentup",
        methods: {
            back(){
                this.$router.back();
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
        .body {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100dvh;
            z-index: 9999;
            min-height: 500px;
            position: fixed;
            top: 0;
            backdrop-filter: blur(10px);
            width: 100dvw;
            left: 0;
            background-color: rgba(32, 33, 36, 0.3);
        }
        .popup-container {
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
            padding: 20px;
            width: 360px;
            text-align: center;
        }
        .popup-icon {
            width: 60px;
            height: 60px;
            background-color: #79db55;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto 15px;
        }
        .popup-icon svg {
            fill: white;
            width: 30px;
            height: 30px;
        }
        .popup-text {
            color: #202124;
            font-size: 16px;
            line-height: 1.5;
    
            span{
                font-weight: bold;
            }
        }
        .popup-button {
            margin-top: 20px;
        }
        .popup-button button {
            background-color: #79db55;
            color: white;
            border: none;
            border-radius: 4px;
            padding: 10px 20px;
            font-size: 14px;
            cursor: pointer;
        }
        .popup-button button:hover {
            background-color: #66c14a;
        }
    </style>